module.exports = __webpack_public_path__ + "img/0Q3B3793_L_BlackMatted.167805c0.jpg";